angular.module('fundersclub.founderOnboarding', [
    'fundersclub.models',
    'ngAnimate',
    'ui.router',
]);
